import { useBasket } from '@hook/useBasket';
import { useUserSubscriptionInfo } from '@hook/useUserSubscriptionInfo';
import { MinOrderPriceSubscriptionBanner } from '@components/MinOrderPriceSubscriptionBanner';

import { useSmartInfoMinPurchaseQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  sellerId: number,
  isSellerLinkExist?: boolean,
}

export const MinOrderPriceSubscriptionBannerContainer: React.FC<Props> = ({
  className,
  sellerId,
  isSellerLinkExist,
}) => {
  const { basket } = useBasket();
  const group = basket?.groups.find(({ seller }) => seller?.id === sellerId);

  const {
    viewer,
  } = useUserSubscriptionInfo({
    context: {
      batch: true,
    },
  });

  const { data: minPurchaseData } = useSmartInfoMinPurchaseQuery({
    context: { batch: true },
  });

  const isSubscriptionActive = !!viewer?.subscriptionInfo?.endAt;
  const orderTotalPrice = Number(group?.info.totalPrice);
  const minOrderPrice = Number(minPurchaseData?.smartInfo.minPurchaseCondition);

  if (
    group
    && isSubscriptionActive
    && orderTotalPrice < minOrderPrice
  ) {
    return (
      <MinOrderPriceSubscriptionBanner
        className={className}
        minOrderPrice={minPurchaseData?.smartInfo.minPurchaseCondition}
        sellerUsername={group.seller?.username || ''}
        isSellerLinkExist={isSellerLinkExist}
      />
    );
  }

  return null;
};
